import type { AnchorHTMLAttributes, ButtonHTMLAttributes, ReactNode } from 'react';

type Variant = 'solid' | 'outline';

interface CommonProps {
  variant?: Variant;
  className?: string;
  children: ReactNode;
}

type ButtonProps = CommonProps & {
  as?: 'button';
} & Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'className' | 'children'>;

type AnchorProps = CommonProps & {
  as: 'a';
} & Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'className' | 'children'>;

type Props = ButtonProps | AnchorProps;

const base =
  'inline-flex items-center justify-center gap-2 px-7 py-3 rounded-full text-xs sm:text-sm font-sans font-medium tracking-widest uppercase transition-all duration-300 focus-visible:ring-2 focus-visible:ring-brand-gold focus-visible:ring-offset-2 ring-offset-brand-paper';

const variants: Record<Variant, string> = {
  solid:
    'bg-brand-gold text-white hover:bg-brand-gold-deep shadow-card hover:shadow-md',
  outline:
    'bg-transparent text-brand-gold border border-brand-gold hover:bg-brand-gold hover:text-white',
};

export default function GoldButton(props: Props) {
  const { variant = 'solid', className = '', children } = props;
  const cls = `${base} ${variants[variant]} ${className}`;

  if (props.as === 'a') {
    const { as: _as, variant: _v, className: _c, children: _ch, ...rest } = props;
    return (
      <a className={cls} {...rest}>
        {children}
      </a>
    );
  }
  const { as: _as, variant: _v, className: _c, children: _ch, ...rest } = props;
  return (
    <button className={cls} {...rest}>
      {children}
    </button>
  );
}
